export const formatCurrency = (value) => new Intl.NumberFormat('en', {
  style: 'currency',
  currency: 'USD',
  currencyDisplay: 'symbol'
}).format(value);
